import apiClient from '../utils/apiClient';

/**
 * Report API Services
 * Báo cáo dashboard theo API_REPORT_DASHBOARD.md
 */

export const reportAPI = {
  /**
   * Top nhân viên hoàn thành nhiều ca khó nhất
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.from_date - Ngày bắt đầu (YYYY-MM-DD)
   * @param {string} params.to_date - Ngày kết thúc (YYYY-MM-DD)
   * @param {number} params.limit - Số lượng kết quả (mặc định: 10)
   * @returns {Promise<Array>} Danh sách nhân viên
   */
  getTopCompletedDifficultShifts: async (params = {}) => {
    const { from_date, to_date, limit = 10 } = params;
    return await apiClient.get({
      url: '/reports/top-completed-difficult-shifts',
      params: { from_date, to_date, limit },
    });
  },

  /**
   * Top nhân viên có điểm thưởng cao nhất
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.from_date - Ngày bắt đầu (YYYY-MM-DD)
   * @param {string} params.to_date - Ngày kết thúc (YYYY-MM-DD)
   * @param {number} params.limit - Số lượng kết quả (mặc định: 10)
   * @returns {Promise<Array>} Danh sách nhân viên
   */
  getTopRewardPoints: async (params = {}) => {
    const { from_date, to_date, limit = 10 } = params;
    return await apiClient.get({
      url: '/reports/top-reward-points',
      params: { from_date, to_date, limit },
    });
  },

  /**
   * Top nhân viên bị trừ điểm nhiều nhất
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.from_date - Ngày bắt đầu (YYYY-MM-DD)
   * @param {string} params.to_date - Ngày kết thúc (YYYY-MM-DD)
   * @param {number} params.limit - Số lượng kết quả (mặc định: 10)
   * @returns {Promise<Array>} Danh sách nhân viên
   */
  getTopDeductedPoints: async (params = {}) => {
    const { from_date, to_date, limit = 10 } = params;
    return await apiClient.get({
      url: '/reports/top-deducted-points',
      params: { from_date, to_date, limit },
    });
  },

  /**
   * Top nhân viên đăng ký ít ca nhất
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.from_date - Ngày bắt đầu (YYYY-MM-DD)
   * @param {string} params.to_date - Ngày kết thúc (YYYY-MM-DD)
   * @param {number} params.limit - Số lượng kết quả (mặc định: 10)
   * @returns {Promise<Array>} Danh sách nhân viên
   */
  getTopLeastRegisteredShifts: async (params = {}) => {
    const { from_date, to_date, limit = 10 } = params;
    return await apiClient.get({
      url: '/reports/top-least-registered-shifts',
      params: { from_date, to_date, limit },
    });
  },

  /**
   * Nhân viên theo tỉ lệ phần thưởng
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.from_date - Ngày bắt đầu (YYYY-MM-DD)
   * @param {string} params.to_date - Ngày kết thúc (YYYY-MM-DD)
   * @param {number} params.limit - Số lượng kết quả (mặc định: 100)
   * @returns {Promise<Array>} Danh sách nhân viên
   */
  getEmployeesByRewardRatio: async (params = {}) => {
    const { from_date, to_date, limit = 100 } = params;
    return await apiClient.get({
      url: '/reports/employees-by-reward-ratio',
      params: { from_date, to_date, limit },
    });
  },

  /**
   * Gửi báo cáo tuần qua Telegram (chỉ ADMIN)
   * @returns {Promise<Object>} Kết quả gửi báo cáo
   */
  sendWeeklyReport: async () => {
    return await apiClient.post({
      url: '/reports/weekly/top-performers/send',
    });
  },

  /**
   * Gửi báo cáo tháng qua Telegram (chỉ ADMIN)
   * @returns {Promise<Object>} Kết quả gửi báo cáo
   */
  sendMonthlyReport: async () => {
    return await apiClient.post({
      url: '/reports/monthly/top-performers/send',
    });
  },
};

